import { isChecklistStepComplete } from '~/components/post-onboarding-checklist/utils'
import { useActiveOrg } from '~/hooks/org'
import { usePostOnboardingChecklist } from '~/hooks/usePostOnboardingChecklist'
import { PostOnboardingChecklistStepKey } from '~/types'

/**
 * Whether the org is in the dashboard's welcome state: it has a
 * post-onboarding checklist whose FUND step is incomplete (and the checklist
 * is not hidden). Driven by the backend checklist, never by transaction
 * counts, so the welcome state survives sponsored transactions like "Enable
 * Auto Earn" and ends only when the org receives funds. Orgs from before the
 * checklist shipped have no checklist and are never in this state. Single
 * source of truth shared by the dashboard and any surface that defers to the
 * welcome screen (e.g. the Splits Connect promo card).
 */
export const useIsGettingStarted = () => {
  const { org } = useActiveOrg()
  const { checklist, isLoading } = usePostOnboardingChecklist()

  const isSettled = !isLoading && !!org

  const isGettingStarted =
    isSettled &&
    !!checklist &&
    !checklist.hidden &&
    !isChecklistStepComplete(checklist, PostOnboardingChecklistStepKey.Fund)

  return { isGettingStarted, isSettled }
}
